import { Directive, TemplateRef, ViewContainerRef, Input } from "@angular/core";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";

@Directive({
    selector: "[userRoleToggle]",
    standalone: true
})
export class UserRoleToggleDirective {
    private hasView = false;

    constructor(private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private store: Store<IAppStore>) {
    }

    @Input()
    set userRoleToggle(roleNames: string[]) {
        this.store.select(e => e.user)
            .subscribe(user => {
                if (user && user.roles && user.roles.some(r => roleNames.indexOf(r) >= 0) && !this.hasView) {
                    this.viewContainer.createEmbeddedView(this.templateRef);
                    this.hasView = true;
                } else {
                    this.viewContainer.clear();
                    this.hasView = false;
                }
            });
    }
}